<template>
    <div ref="container" style="height: 100%; "></div>
</template>
<script>
import bb, {gauge} from "billboard.js";
// import "billboard.js/dist/billboard.css";

export default{
    props: {
        widgets: {
            type: Object,
            required: true,
        },
        data: {
            type: Array,
            required: true,
        },
        paddingSize: {
            type: Number,
            default: 10,
        }
    },
    computed: {
        value(){
            if(this.data.length > 0 && this.widgets.measures?.length > 0){
                return this.data[0][this.widgets.measures[0].Name];
            }else{
                return 0;
            }
        }
    },
    mounted(){
        this.draw()
    },
    methods: {
        draw(){
            const chart = bb.generate({
                bindto: this.$refs.container,
                data: {
                    columns: [
                        ["data", this.value]
                    ],
                    type: gauge(),
                },
                gauge: {
                    label: {
                        format: function(value, ratio) {
                            return value;
                        },
                        show: true // to turn off the min/max labels.
                    },
                },
                legend: {
                    show: false
                },
                color: {
                    pattern: ["#FF0000", "#F97600", "#F6C600", "#60B044"],
                    threshold: {
                        values: [30, 60, 90, 100]
                    }
                },
                padding: {
                    mode: "fit",
                    top: this.paddingSize,
                    bottom: this.paddingSize,
                    left: this.paddingSize,
                    right: this.paddingSize,
                },
            });
        }
    }
}
</script>